import { render, staticRenderFns } from "./DropsmartCenterFooter.vue?vue&type=template&id=59ddc791&scoped=true&"
import script from "./DropsmartCenterFooter.vue?vue&type=script&lang=js&"
export * from "./DropsmartCenterFooter.vue?vue&type=script&lang=js&"
import style0 from "./DropsmartCenterFooter.vue?vue&type=style&index=0&id=59ddc791&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ddc791",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BButton, BIconGlobe} from 'bootstrap-vue'
    installComponents(component, {BButton, BIconGlobe})
    

export default component.exports